import { useState } from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { ContentLayoutF } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { Header } from './components/header/Header';
import { TimeWeightedReturns } from './components/time-weighted-returns/TimeWeightedReturns';
import { PerformanceAccountDocument } from './graphql/performanceAccount.generated';

import { DateRangeOption } from '../../graphql/schema';
import { ApplicationLayout } from '../../Shared/layout/ApplicationLayout';
import { accountsByType } from '../shared/utils';

export const AccountPerformancePage: React.FC = () => {
  const [dateRangeOption, setDateRangeOption] = useState<DateRangeOption>(DateRangeOption.AllTime);

  const accountId = useRequiredParam('accountId');

  const { data } = useGraphQLQuery(PerformanceAccountDocument, {
    variables: { accountIds: [accountId] },
    throwOnError: true,
  });

  if (!data) {
    return null;
  }

  const { investingAccounts } = accountsByType(data.performance.accounts);
  const isInvestingAccount = investingAccounts.length > 0;

  return (
    <ErrorBoundary fallbackType="full" feature="performance" owner="investing_experience">
      <ApplicationLayout pageTitle="Performance" feature="performance">
        <ApplicationLayout.Header>
          <Header accountId={accountId} dateRangeOption={dateRangeOption} setDateRangeOption={setDateRangeOption} />
        </ApplicationLayout.Header>
        <ApplicationLayout.Content>
          <ContentLayoutF>
            <ContentLayoutF.SlotContainer css={{ paddingTop: 'space.400' }}>
              <ContentLayoutF.Slot1
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <div>Balance component placeholder</div>
                {isInvestingAccount && <TimeWeightedReturns accountId={accountId} dateRangeOption={dateRangeOption} />}
              </ContentLayoutF.Slot1>
              <ContentLayoutF.Slot2
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <div>Returns card placeholder</div>
              </ContentLayoutF.Slot2>
            </ContentLayoutF.SlotContainer>
          </ContentLayoutF>
        </ApplicationLayout.Content>
      </ApplicationLayout>
    </ErrorBoundary>
  );
};
